<template>
  <Page type="no-header">

      <Desk />
  </Page>
</template>

<script>
import Page from '@/components/visual/Page'
import Desk from '@/components/panchanga/Desk'

export default {
    components: { Page, Desk },
    data() {
      return {
      }
    },
}
</script>

<i18n locale="ru" lang="yaml">
  pageTitle: "Панчанга"
</i18n>

<i18n locale="en" lang="yaml">
  pageTitle: "Panchanga"
</i18n>
